import styled, {
  keyframes,
} from 'styled-components';
import {
  lighten,
} from 'polished';

import {
  Flex,
} from 'web-styled';

export const Spinner = styled(Flex).attrs({
  column: true,
  fillSpace: true,
  align: 'center',
  justify: 'center',
  spacing: 15,
})`
  position: ${props => (props.over ? 'absolute' : 'relative')};
  z-index: 9999;
`;

const spin = keyframes`
  0% { transform: rotate(0);}
  100% {transform: rotate(359deg);}`;

export const Indicator = styled.div`
  position: relative;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  box-shadow: black 0px 0px 8px -3px;
  border-radius: 30px;
  box-sizing: border-box;
  background-color: white;

  .hand {
    position: absolute;
    will-change: rotate;
    transform-origin: 50% 66%;
    animation: ${spin} 1s infinite linear;
  }
`;

export const Message = styled.div`
  color: ${props => props.theme.colors?.spinner || '#74c8f1'};
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  line-height: 1.4;
  border-radius: 5px;
  box-shadow: #222 0px 0px 8px -3px;
  padding: 2px 5px;
  background: ${props => lighten(0.25, props.theme.colors?.spinner || '#74c8f1')};
`;

export const Path = styled.path.attrs({
  fill: 'none',
  strokeDasharray: 'none',
  strokeLinecap: 'butt',
  strokeLinejoin: 'miter',
  strokeMiterlimit: 4,
  strokeOpacity: 1,
  strokeWidth: 0.42333332,
})`
  stroke: ${props => props.theme.colors?.spinner || '#74c8f1'};
`;

export const Ellipse = styled.ellipse.attrs({
  fill: 'none',
  fillOpacity: 1,
  opacity: 1,
  strokeDasharray: 'none',
  strokeMiterlimit: 4,
  strokeOpacity: 1,
})`
  stroke: ${props => props.theme.colors?.spinner || '#74c8f1'};
`;
